// React Imports
import React from 'react';

import 'components/card/service/serviceCard.style.scss';
import Helper from '../../../core/helper/helper';
import RightArrowButton from '../../button/rightArrowButton';
import ServiceFeedbackCard from './serviceFeedbackCard';
import CheckInDate from './checkInDate';
import CheckOutDate from './checkOutDate';
import CardCorner from './cardCorner';
import CardItemInformation from '../equipment/CardItemInformation';
import CardServiceState from './CardServiceState';
import ServiceNotificationWidgets from './serviceNotificationWidgets';
import { ToastState } from '../../../core/types';
import { HelperSchedule } from '../../../views/schedule/core/helpers/helperSchedule';
import LocalData from '../../../core/localData';

class CardService extends React.PureComponent {

  constructor(props) {
    super(props);
    const is_product_services = LocalData.configData.worksheet_operational === "false";
    const {
      isLiteVersion, isCompact, isAppointment,
      data: { id, item, phase, state, allow_cancel, allow_approve,
         date_start, old_date, date_end, time, time_end, old_time, feedback, schedule, service_toast_state,
         message_toast_state, payment_toast_state, show_has_internal_notes_icon, payment, work_id, is_cancelled,
         is_history, is_confirmed, client_arrived, credit_value, payment_status, full_day}
    } = this.props;
    const missedAppointment = !work_id && !is_cancelled && is_history && isAppointment && !client_arrived;
    this.refInput = React.createRef();
    this.state = {
      id: id,
      item: Helper.initialItemState(item, isLiteVersion, isAppointment),
      phase: phase,
      state: {
        bars: state?.bars,
        name: credit_value && credit_value !== "0,00"
            ? 'Pendente de Pagamento'
            : payment && payment.state &&
            ((payment?.state !== 'PAYED' && state.bars === 4) || (isAppointment && payment?.state !== 'PAYED'))
            ? 'Pendente de Pagamento'
              : (payment && payment.state && state && payment.state !== 'PAYED' && state.bars === 3 && is_product_services)
              ? 'Pendente de Pagamento'
              : payment_status && payment_status !== 'PAYED' && payment_status !== 'PAID'
                ? 'Pendente de Pagamento'
                : state?.bars === 2.5 && !allow_approve
                  ? 'Aguarda aprovação'
                  : isAppointment
                    ? HelperSchedule.getAppointmentStateBarsDescription(this.props.data)
                    : state?.bars === 1 && is_product_services
                      ? 'Pedido a decorrer'
                      : state?.name,
      },
      allowCancel: allow_cancel,
      allowApprove: allow_approve,
      dateStart: Helper.printDate(date_start),
      old_date: old_date,
      time: time,
      timeEnd: time_end,
      old_time: old_time,
      dateEnd: Helper.printDate(date_end),
      feedback: feedback,
      schedule: schedule,
      isCompact: isCompact || false,
      stateAction: allow_approve || (payment_toast_state === ToastState.EXPANDED), //state.bars === 2.5, // aguarda aprovação
      stateCheck: state.bars === 4, // aguarda cliente
      showUnreadCheck: service_toast_state === 'EXPANDED', // aguarda cliente expandido
      stateMessage: message_toast_state !== 'IGNORE' && !!message_toast_state, // tem mensagem de prestador
      showUnreadMessage: message_toast_state === 'EXPANDED',
      showInternalNotes: show_has_internal_notes_icon,
      isAppointment: isAppointment,
      showPaymentAction: payment_toast_state === ToastState.EXPANDED,
      is_cancelled: is_cancelled,
      missedAppointment: missedAppointment,
      is_confirmed: is_confirmed,
      is_history: is_history,
      date_start: date_start,
      date_end: date_end,
      full_day: full_day,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      const is_product_services = LocalData.configData.worksheet_operational === "false";
      const {
        isLiteVersion, isCompact, isAppointment,
        data: { id, item, phase, state, allow_cancel, allow_approve, date_start, old_date, date_end, time, 
          old_time, feedback, schedule, service_toast_state, message_toast_state, payment_toast_state, 
          show_has_internal_notes_icon, payment, work_id, is_cancelled, is_history, is_confirmed, client_arrived, credit_value, payment_status, full_day }
      } = this.props;
      const missedAppointment = !work_id && !is_cancelled && is_history && isAppointment && !client_arrived;
      this.setState({
        id: id,
        item: Helper.initialItemState(item, isLiteVersion, isAppointment),
        phase: phase,
        state: {
          bars: state?.bars,
          name: credit_value && credit_value !== "0,00"
            ? 'Pendente de Pagamento'
            : (payment && payment.state &&
            ((payment?.state !== 'PAYED' && state.bars === 4) || (isAppointment && payment.state !== 'PAYED')))
            ? 'Pendente de Pagamento'
            : (payment && payment.state && state && payment.state !== 'PAYED' && state.bars === 3 && is_product_services)
              ? 'Pendente de Pagamento'
              : payment_status && payment_status !== 'PAYED' && payment_status !== 'PAID'
                ? 'Pendente de Pagamento'
                : state?.bars === 2.5 && !allow_approve
                  ? 'Aguarda aprovação'
                  : isAppointment
                    ? HelperSchedule.getAppointmentStateBarsDescription(this.props.data)
                    : state?.bars === 1 && is_product_services
                      ? 'Pedido a decorrer'
                      : state?.name,
        },
        allowCancel: allow_cancel,
        allowApprove: allow_approve,
        dateStart: Helper.printDate(date_start),
        old_date: old_date,
        time: time,
        old_time: old_time,
        dateEnd: Helper.printDate(date_end),
        feedback: feedback,
        schedule: schedule,
        isCompact: isCompact || false,
        stateAction: allow_approve || (payment_toast_state === ToastState.EXPANDED), //state.bars === 2.5, // aguarda aprovação
        stateCheck: state.bars === 4, // aguarda cliente
        showUnreadCheck: service_toast_state === ToastState.EXPANDED, // aguarda cliente expandido        
        stateMessage: message_toast_state !== ToastState.IGNORE && !!message_toast_state,
        showUnreadMessage: message_toast_state === ToastState.EXPANDED,
        showInternalNotes: show_has_internal_notes_icon,
        showPaymentAction: payment_toast_state === ToastState.EXPANDED,
        isAppointment: isAppointment,
        is_cancelled: is_cancelled,
        missedAppointment: missedAppointment,
        is_confirmed: is_confirmed,
        is_history: is_history,
        date_start: date_start,
        date_end: date_end,
        full_day: full_day,
      });
    }
  }

  handlePressEvent = () => {
    this.props.onClick(this.state.id);
  }

  validateSubmition = (feedback, isSubmition) => {
    if (isSubmition) {
      return this.props.callback(this.state.id, feedback);
    }
  }

  renderCheckinDate = (dateStart, schedule) => {
    const { state: { bars } } = this.state;
    return <CheckInDate data={{bars, dateStart, schedule, dateStartState: this.state.dateStart}}/>
  }

  renderCheckoutDate = (dateEnd) => {
    const { state: { bars } } = this.state;
    return <CheckOutDate data={{bars, dateEnd, dateEndState: this.state.dateEnd}}/>
  }

  renderItemInformation = (isCompact) => {
    if (isCompact) {
      return <></>;
    }
    const { item: { title, subtitle } } = this.state;
    return <CardItemInformation data={{ title, subtitle, id: this.state.id }}/>
  }

  renderCardCorner = (bars, feedback) => {
    const { isAppointment } = this.state;
    return <CardCorner data={{bars, feedback, isAppointment}}/>
  }

  renderCardServiceState = () => {
    const { data: {date_start, date_end, schedule, is_confirmed, is_history, full_day}} = this.props;
    const { state, dateStart, old_date, dateEnd, time, timeEnd, old_time, isAppointment, is_cancelled, missedAppointment } = this.state;
    return (
      <CardServiceState
        data={{
          dateStart: date_start,
          old_date: old_date,
          schedule,
          dateEnd: isAppointment ? undefined : date_end,  //only show appointment end date on the details page
          time: time,
          timeEnd,
          old_time: old_time,
          state,
          dateStartState: dateStart,
          dateEndState: dateEnd,
          isAppointment: isAppointment,
          is_confirmed: is_confirmed,
          is_history: is_history,
          is_cancelled: is_cancelled,
          missedAppointment: missedAppointment,
          full_day: full_day,
        }}
        isSmall={true}
      />
    );
  }

  renderCardImage = (isCompact, item) => {
    if (isCompact) {
      return <></>;
    }

    return (
      <div className="card-service-image-container">
        <img
          src={item.image}
          alt="service_image"
          loading="lazy"
          className={Helper.isLiteVersion() ? "pixelized" : ""}
          onError={(e) => (e.target.src = Helper.defaultImage())}
        />
      </div>
    );
  }

  render() {
    const { data: { feedback, is_history } } = this.props;
    const { state, item, isCompact, stateAction, stateCheck, stateMessage, showUnreadCheck, showUnreadMessage, allowApprove, showInternalNotes, showPaymentAction, isAppointment, is_cancelled, missedAppointment } = this.state;
    const styleClass =  isCompact ? 'is-compact' : '';
    const is_scheduler_solo = LocalData.configData.is_scheduler_solo;

    if ((state.bars === 5 && !feedback && !isCompact && !isAppointment) || (is_scheduler_solo && is_history && isAppointment && !feedback && !isCompact && !is_cancelled && !missedAppointment)) {
      return (
        <ServiceFeedbackCard data={this.state} onClick={this.handlePressEvent}
          callback={this.validateSubmition} />
      );
    }

    const { containerStyle } = this.props;
    return (
      <div className={`card-service-main-container p-2 ${styleClass}`} onClick={this.handlePressEvent} style={containerStyle}>
        <ServiceNotificationWidgets
            data={{stateAction, stateCheck, stateMessage, showUnreadCheck, showUnreadMessage, showInternalNotes, allowApprove, isCompact, showPaymentAction}}
            goToDetails={this.handlePressEvent}/>  
        {this.renderCardCorner(state.bars, feedback)}
        {this.renderItemInformation(isCompact)}
        {this.renderCardImage(isCompact, item)}
        {this.renderCardServiceState()}
        <div className='d-none d-md-block'><RightArrowButton /></div>
      </div>
    );
  }
}

export default CardService;